// userSlice.js
import { createSlice } from '@reduxjs/toolkit';
import API from './../api';
const userSlice = createSlice({
  name: 'user',
  initialState: {
    isSignedIn: (localStorage.getItem('signedIn') === '1' || localStorage.getItem('signedIn') === 'true') ? true : false, // Ajoute un champ isSignedIn
    isAdmin: (localStorage.getItem('isAdmin') === '1' || localStorage.getItem('isAdmin') === 'true') ? true : false, // Ajoute un champ isSignedIn    
    pendingOrders: 0,
  },
  reducers: {
    // isSignedIn: () => {
    //   return
    // },
    setUser: (state, action) => {
      for (const k in action.payload) {
        state[k] = action.payload[k]
      }
      state.isSignedIn = true; // Définit isSignedIn à true lorsque l'utilisateur est connecté
      localStorage.setItem('signedIn', true);
      if (action.payload.type) {
        localStorage.setItem('type', action.payload.type);
      }
      if (state.isAdmin) {
        state.isAdmin = true; // Définit isSignedIn à true lorsque l'utilisateur est connecté
        localStorage.setItem('isAdmin', true);
      } else {
        state.isAdmin = false; // Définit isSignedIn à true lorsque l'utilisateur est connecté
        localStorage.removeItem('isAdmin');
      }
    },
    updateUser: (state, action) => {
      for (const k in action.payload) {
        state[k] = action.payload[k]
      }
    },
    clearUser: (state) => {
      state.isSignedIn = false;
      state.isAdmin = false;
      for (let key in state) {
        if (key !== 'isSignedIn') {
          state[key] = Array.isArray(state[key]) ? [] : null;
          state[key] = undefined;
        }
      }
      localStorage.removeItem('token');
      localStorage.removeItem('signedIn');
      localStorage.removeItem('isAdmin');
      API.post('/user/signOut');
      // window.postMessage({ type: 'userSignIn', signedIn: false }, '*');
    },
  },
});
export const { setUser, updateUser, clearUser } = userSlice.actions;
export const getUserToken = (state) => state.token;
export default userSlice.reducer;
export const fetchUser = () => async (dispatch, getState) => {
  const state = getState().user
  if (state.isSignedIn) {
    try {
      const response = await API.get('/user');
      if (response.data.status != 'active') {
        dispatch(clearUser());
      } else {
        dispatch(updateUser(response.data));
      }
    } catch (e) { }
  }
};
